(function () {
  let observer = null;
  const revealOptions = {
    root: null,
    rootMargin: '0px 0px -50px 0px',
    threshold: 0
  };

  const revealCallback = function (entries, obs) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        requestAnimationFrame(() => {
          entry.target.classList.add('reveal-visible');
        });
        obs.unobserve(entry.target);
      }
    });
  };

  const initReveal = function () {
    if (!observer) {
      observer = new IntersectionObserver(revealCallback, revealOptions);
    }
    const elementsToReveal = document.querySelectorAll('.reveal-hidden, .main .shopify-section:not(.reveal-visible)');
    elementsToReveal.forEach(el => observer.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  // Shopify Editor Event: Re-observe sections injected dynamically
  document.addEventListener('shopify:section:load', function(event) {
    if (!observer) {
      observer = new IntersectionObserver(revealCallback, revealOptions);
    }
    
    const section = event.target;
    
    // Immediately reveal the section in the editor to prevent "white ghost block"
    if (window.Shopify && Shopify.designMode) {
      section.classList.add('reveal-visible');
    } else {
      if (section.classList && section.classList.contains('shopify-section')) {
        observer.observe(section);
      }
    }
    
    const innerElements = section.querySelectorAll('.reveal-hidden');
    innerElements.forEach(el => observer.observe(el));
  });
})();
